<form class="search-list-common">
  <div class="input-group form-control">
    <div class="input-group-append">
      <button type="submit" class="btn" id="cs-button-search-{{searchId}}-id" (click)="search(textInput)"><i class="pw-search fa-lg"></i></button>
    </div>
    <input type="text" class="form-control" [placeholder]="placeholder" name="searchInput"
           [(ngModel)]="textInput"
           (keyup.enter)="search(textInput)"
           id="{{searchId}}"
           #input/>

    <span *ngIf="textInput" class="icon-remove input-search"
          (click)="clearInput()" id="{{searchId}}-btn-remove-id">
                              <c-icon [name]="'remove'"></c-icon>
                            </span>

  </div>
</form>
